import type { EncodedResponse, ResponsesArtifact } from '../../data/types';

export type VisitCohort = 'first' | 'occasional' | 'frequent';

export interface OnboardingAnswers {
  visit: VisitCohort | null;
  age: string | null;
}

const VISIT_LABELS: Record<VisitCohort, readonly string[]> = {
  first: ['今回が初めて'],
  occasional: ['年に1回程度', '年に2～3回程度'],
  frequent: ['月に1回程度', '月に2～3回程度', '週に1回以上', 'ほぼ毎日'],
};

export const VISIT_OPTIONS: Array<{ value: VisitCohort; label: string; note: string }> = [
  { value: 'first', label: 'はじめて', note: '今回が初めて' },
  { value: 'occasional', label: '年に数回', note: '年1回〜年2、3回' },
  { value: 'frequent', label: '月に1回以上', note: '月1回〜ほぼ毎日' },
];

function codeSet(labels: readonly string[], codebook: readonly string[]): Set<number> {
  const codes = labels.map((label) => codebook.indexOf(label));
  if (codes.some((code) => code < 0)) throw new Error('来館頻度コードが見つかりません');
  return new Set(codes);
}

export function matchesOnboardingAnswers(
  row: EncodedResponse,
  artifact: ResponsesArtifact,
  answers: OnboardingAnswers,
): boolean {
  if (answers.visit) {
    const accepted = codeSet(VISIT_LABELS[answers.visit], artifact.codebook.visit_frequency);
    if (!accepted.has(row.visit_frequency)) return false;
  }
  if (answers.age) {
    const ageCode = artifact.codebook.age_group.indexOf(answers.age);
    if (ageCode < 0) throw new Error(`年代コードが見つかりません: ${answers.age}`);
    if (row.age_group !== ageCode) return false;
  }
  return true;
}

export function matchingRespondentIds(
  artifact: ResponsesArtifact,
  answers: OnboardingAnswers,
): Set<number> | undefined {
  if (!answers.visit && !answers.age) return undefined;
  return new Set(
    artifact.rows
      .filter((row) => matchesOnboardingAnswers(row, artifact, answers))
      .map((row) => row.id),
  );
}
